import { Flex, Heading, Image } from '@chakra-ui/react';
import { memo } from 'react';
import { Link } from 'react-router-dom';

import { ColorModeSwitcher } from './ColorModeSwitcher';
function Header() {
  return (
    <Flex align='center' bg='blue.400' justify='space-between' p='2' w='100%'>
      <Flex align='center' direction='row'>
        <Link to={`/`}>
          <Image alt='InvGate logo' height='32px' mr='4' src='/logo.svg' />
        </Link>
        <Heading color='white' size='md'>
          Casa Ley
        </Heading>
      </Flex>
      <ColorModeSwitcher ml='4' />
    </Flex>
  );
}

export default memo(Header);
